import React from "react";
import FooterMenu from "./FooterMenu";
import CookieConsent from "./CookieConsent";

const Footer: React.FC = () => {
    return (
        <footer>
            <div className="container">
                <FooterMenu></FooterMenu>
            </div>
            <CookieConsent></CookieConsent>
        </footer>
    )

};

export default Footer;
